// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"modal_modal_wrapper__2Qr8b","modal_container":"modal_modal_container__cNAmJ","header":"modal_header__ZwXoQ","close_button":"modal_close_button__l-zBj"};